import script from "./editableTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./editableTitle.vue?vue&type=script&setup=true&lang=ts"

import "./editableTitle.vue?vue&type=style&index=0&id=43895c05&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43895c05"]])

export default __exports__